// @flow
import React, { Component } from "react";

import UserAuth from "../../global/containers/UserAuth";
import RedirectoLogin from "../../account/views/RedirectoLogin";
import { AppHeader } from "imagus-components";
import AdminFacebases from "../containers/facebases/AdminFacebases";
import Navbar from "../containers/Navbar";

class Facebases extends Component<*> {

  render(): * {
    return (
      <UserAuth principal='facebase-admin' unAuthChildren={<RedirectoLogin />} >
        <div className="app-main">
          <AppHeader
            title="Site Administration"
            IconName="SettingsApplications"
          />
          <Navbar router={this.props.router} />
          <AdminFacebases />
        </div>
      </UserAuth>
    );
  }
}

export default Facebases;
